import toCamelCase from '../toCamelCase';

export default function getImpactBlockData(props) {
  const {
    fields: { theImpact },
  } = props;

  const data = {};

  if (theImpact) {
    data.title = 'The Impact';
    data.id = toCamelCase(data.title);
    data.content = theImpact || false;
    data.buttons = [];

    data.buttons = [];

    data.buttons.share = [];
    const sharebutton = {};
    sharebutton.label = 'Share this playbook';
    sharebutton.type = 'share';
    sharebutton.modifier = 'Button--electricPurpleFill';
    data.buttons.push(sharebutton);

    // data.buttons.download = [];
    // const downloadButton = {};
    // downloadButton.label = 'Download this playbook';
    // downloadButton.type = 'download';
    // downloadButton.modifier = 'Button--electricPurple';
    // data.buttons.push(downloadButton);
  }

  return Object.keys(data).length ? data : false;
}
